import { createFileRoute } from '@tanstack/react-router';
import StaffPortal from '../../components/portals/StaffPortal';
import PromoValidation from '../../components/reception/PromoValidation';

export const Route = createFileRoute('/staff/promos')({
  component: StaffPromosRoute,
});

function StaffPromosRoute() {
  return (
    <StaffPortal>
      <PromoValidation />
    </StaffPortal>
  );
}
